import { render } from "./CompletedExams.vue?vue&type=template&id=8ed6d5be&scoped=true"
import script from "./CompletedExams.vue?vue&type=script&lang=js"
export * from "./CompletedExams.vue?vue&type=script&lang=js"

import "./CompletedExams.vue?vue&type=style&index=0&id=8ed6d5be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ed6d5be"]])

export default __exports__